<template>Tu bude vložený modul na komunikáciu s podporou aplikácie</template>
